export default __webpack_public_path__ + "static/Web437_DOS-V_re_ANK16-8a9ad0c91d092ef53f948f4cc437bf67.woff";